import React from 'react';
import {Typography} from "@mui/material";
import BottomBorder from "../BottomBorder";
import {AiMentionsProseContent} from "../../models/AiMentionsContent";

interface WhyNowProps {
    content: AiMentionsProseContent;
}

const WhyNow: React.FC<WhyNowProps> = ({content}) => (
    <section className="lnk-aim__whynow">
        <div className="lnk-aim__title-block lnk-aim__title-block--center">
            <Typography variant="h2">{content.title}</Typography>
            <BottomBorder width={69} addMargin={false}/>
        </div>
        {/* pre-line: an Enter in the admin's textarea is a line break here */}
        <p style={{whiteSpace: "pre-line"}}>{content.body}</p>
    </section>
);

export default WhyNow;
